import { State, Action, Selector, StateContext } from '@ngxs/store';
import { ToggleFullscreenMode, SetLanguage } from './app.actions';
import { Language } from '../../../common/constants';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export interface AppStateModel {
  currentLanguage: Language;
  fullscreenMode: boolean;
}

@State<AppStateModel>({
  name: 'app',
  defaults: {
    currentLanguage: Language.En,
    fullscreenMode: false,
  },
})
@Injectable()
export class AppState {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  @Selector()
  static getState(state: AppStateModel): AppStateModel {
    return state;
  }

  @Selector()
  static getLanguage(state: AppStateModel): Language {
    return state.currentLanguage;
  }

  @Selector()
  static getFullscreenMode(state: AppStateModel): boolean {
    return state.fullscreenMode;
  }

  @Action(SetLanguage)
  setLanguage(ctx: StateContext<AppStateModel>, { payload }: SetLanguage): void {
    const stateModel = ctx.getState();
    ctx.setState({
      ...stateModel,
      currentLanguage: payload,
    });
  }

  @Action(ToggleFullscreenMode)
  changeFullscreenMode(ctx: StateContext<AppStateModel>): void {
    const stateModel = ctx.getState();

    stateModel.fullscreenMode
      ? this.document.exitFullscreen().then()
      : this.document.documentElement.requestFullscreen().then();
    ctx.setState({
      ...stateModel,
      fullscreenMode: !stateModel.fullscreenMode,
    });
  }
}
